import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading skeleton for the assistant chat screen. Mirrors WorkspaceTopBar
 * (compact AppHeaderRail) above a centered message thread and a bottom
 * composer card matching ChatInput's compact layout.
 */
export function ChatSkeleton() {
  return (
    <div className="flex h-screen flex-col">
      <header className="border-b bg-background">
        <div className="flex min-h-12 items-center gap-3 px-4 py-2 md:px-6">
          <Skeleton className="size-8 shrink-0 rounded-md" />
          <Skeleton className="h-4 w-40" />
        </div>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-6 md:px-8">
        <div className="mx-auto flex max-w-3xl flex-col gap-6">
          <div className="ml-auto w-2/3">
            <Skeleton className="h-16 rounded-md" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/6" />
          </div>
          <div className="ml-auto w-1/2">
            <Skeleton className="h-12 rounded-md" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-5/6" />
          </div>
          <div className="ml-auto w-3/5">
            <Skeleton className="h-14 rounded-md" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        </div>
      </div>
      <div className="border-t bg-background/95 p-4 backdrop-blur">
        <div className="mx-auto max-w-3xl">
          <Skeleton className="h-[4.5rem] w-full rounded-md" />
        </div>
      </div>
    </div>
  );
}
